"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptionList = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const atoms_1 = require("../../atoms");
function DescriptionList({ testId, className, children, }) {
    return (react_1.default.createElement("dl", { className: (0, classnames_1.default)('grid', 'gap-4', 'grid-cols-1', '[&>dt]:white-space-nowrap', '[&>dt]:col-span-1', '[&>dd]:col-span-2', '[&>dd]:break-words', 'md:grid-cols-3', className), "data-testid": testId }, children));
}
exports.DescriptionList = DescriptionList;
DescriptionList.Item = ({ label, description, forceCapitalization, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("dt", { className: "white-space-nowrap col-span-1" },
        react_1.default.createElement(atoms_1.Text, { type: atoms_1.TextType.BODY_M, subdued: true }, label)),
    react_1.default.createElement("dd", { className: "break-words col-span-2" },
        react_1.default.createElement(atoms_1.Text, { type: atoms_1.TextType.BODY_M, forceCapitalization: forceCapitalization }, description))));
//# sourceMappingURL=DescriptionList.js.map